exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settings-card .card-body {\n  padding: 0;\n  overflow: hidden;\n}\n", ""]);

// exports
